import { render, staticRenderFns } from "./ContinuesDevelopment.vue?vue&type=template&id=3c949518&scoped=true&"
import script from "./ContinuesDevelopment.vue?vue&type=script&lang=js&"
export * from "./ContinuesDevelopment.vue?vue&type=script&lang=js&"
import style0 from "./ContinuesDevelopment.vue?vue&type=style&index=0&id=3c949518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c949518",
  null
  
)

export default component.exports